module.exports = __webpack_public_path__ + "img/vertical_7_2_8023.8a1839f5.png";